import { captureException } from '@sentry/vue'

import { container, TYPES } from '@/libs/di/inversify.config'
import { useWebSocket } from '@vueuse/core'

type onUpdateChatRoom = (chatRoomId: string[]) => void

export function useUpdatedChatRoom(
  plannerID: string,
  entranceGUID: string,
  onUpdateChatRoom: onUpdateChatRoom,
  onConnected?: () => void
) {
  const config = container.get(TYPES.APIConfig)
  if (!config.apiToken) return

  const query = entranceGUID.length > 0 ? `?entrance-guid=${entranceGUID}` : ''
  // https://vueuse.org/core/usewebsocket/
  useWebSocket(`${config.cinnamonWsUrl}/ws/planner/${plannerID}${query}`, {
    protocols: [encodeURIComponent(config.apiToken.toString())],
    autoReconnect: {
      retries: 3,
      delay: 1000,
      onFailed() {
        captureException('Failed to connect WebSocket after 3 retries')
      },
    },
    onMessage: (_, event) => {
      try {
        const data = JSON.parse(event.data) as { room_ids: number[] }
        onUpdateChatRoom(data.room_ids.map(id => id.toString()))
      } catch (e) {
        captureException(e)
      }
    },
    onConnected: () => {
      onConnected?.()
    },
  })
}
